import {isCurrentTimeBetween} from "./DateTimeUtills";

export function differenceInTimeToText(from, to, t)
{
    if(!(from instanceof Date))
    {
        from = new Date(from)
    }
  if(from === undefined || isNaN(from))
  {
    return t("global.time.unknown")
  }

  if(!to)
  {
    to = new Date();
  }
  const timeDifference = to - from;

  const seconds = Math.floor(timeDifference / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  const agoStr = t('global.time.ago')

  if (days > 0) {
    return days === 1 ? `1 ${t('global.time.units.singular.day')} ${agoStr}` : `${days} ${t('global.time.units.plural.day')} ${agoStr}`;
  } else if (hours > 0) {
    return hours === 1 ? `1 ${t('global.time.units.singular.hour')} ${agoStr}` : `${hours} ${t('global.time.units.plural.hour')} ${agoStr}`;
  } else if (minutes > 0) {
    return minutes === 1 ? `1 ${t('global.time.units.singular.minute')} ${agoStr}` : `${minutes} ${t('global.time.units.plural.minute')} ${agoStr}`;
  } else {
    return t("global.time.justNow")
  }
}

export function formatDateTime(from, to)
{
    if(from === undefined || isNaN(from))
    {
        return "Unknown"
    }

    if(to === undefined)
    {
        to = new Date();
    }

    const ONE_MINUTE = 60;
    const ONE_HOUR = 3600;
    const ONE_DAY = 86400;

    const difference = Math.abs(from - to);
    const seconds = Math.floor(difference / 1000);

    if (seconds < ONE_MINUTE) {
        return seconds + " seconds ago";
    } else if (seconds < ONE_HOUR) {
        const minutes = Math.floor(seconds / ONE_MINUTE);
        return minutes === 1 ? "1 minute ago" : minutes + " minutes ago";
    } else if (seconds < ONE_DAY) {
        const hours = Math.floor(seconds / ONE_HOUR);
        const remainingMinutes = Math.floor((seconds % ONE_HOUR) / ONE_MINUTE);
        const hourStr = hours === 1 ? "1 hour" : hours + " hours";
        const minuteStr = remainingMinutes === 1 ? "1 minute" : remainingMinutes + " minutes";
        return `${hourStr} ${minuteStr} ago`;
    } else {
        const days = Math.floor(seconds / ONE_DAY);
        return days === 1 ? "1 day ago" : days + " days ago";
    }
}
export function differenceInSeconds(from, to)
{
    if(from === undefined)
    {
      return NaN
    }
    if(to === undefined)
    {
        to = new Date();
    }
    const timeDifference = to - from;

    return  Math.floor(timeDifference / 1000);
}

export function differenceInMinutes(from, to)
{
    if(from === undefined)
    {
        return NaN
    }
    if(to === undefined)
    {
        to = new Date();
    }

    if(!(from instanceof Date))
    {
        from = new Date(from)
    }

    const timeDifference = to - from;
    return  Math.floor((timeDifference / 1000) / 60);
}

export function differenceInHours(from, to, roundTo = 2)
{
  const timeDifference = Math.abs(from.getTime() - to.getTime());
  const hoursDifference = timeDifference / (1000 * 60 * 60); // Convert milliseconds to hours
  return roundToDecimalPlaces(hoursDifference, roundTo) ;
}

export function roundToDecimalPlaces(number, decimalPlaces) {
  const factor = Math.pow(10, decimalPlaces);
  return Math.round(number * factor) / factor;
}


export async function sleep(time)
{
  return new Promise(res => setTimeout(res, time))
}

export function formatDateStr(inputDate)
{
  const date = new Date(inputDate);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
}

export function formatDuration(duration, t) {
    // Check if the duration is less than an hour
    if(duration < 0.01)
    {
        return t('global.time.lessThanMinute')
    }
    if (duration < 1) {
        const minutes = Math.round(duration * 60);
        return `${minutes} ${minutes !== 1 ? t('global.time.units.plural.minute') : t('global.time.units.singular.minute')}`;
    }

    // Extract the integer part (hours)
    const hours = Math.floor(duration);

    // Calculate the remaining minutes
    const minutes = Math.round((duration - hours) * 60);

    // Build the human-readable time format
    let result = `${hours} ${hours !== 1 ? t('global.time.units.plural.hour') : t('global.time.units.singular.hour')}`;

    if (minutes > 0) {
        result += ` ${t('global.time.and')} ${minutes} ${minutes !== 1 ? t('global.time.units.plural.minute') : t('global.time.units.singular.minute')}`;
    }
    return result;
}

export function formatISO8601Short(dateTime) {
    if(!(dateTime instanceof Date))
    {
        dateTime = new Date(dateTime)
    }

    const hours = dateTime.getHours().toString().padStart(2, '0'); // Get hours and pad with leading zero if needed
    const minutes = dateTime.getMinutes().toString().padStart(2, '0'); // Get minutes and pad with leading zero if needed
    return `${hours}:${minutes}`;
}

export function formatDateTimeString(inputString) {
    // Step 1: Parse the input string into a Date object
    const date = new Date(inputString);

    // Step 2: Extract day, month, year, and time
    const day = date.getDate();
    const month = date.getMonth(); // 0-indexed, so January is 0, February is 1, etc.
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();

    // Step 3: Convert the day to its ordinal form
    const ordinalDay = getOrdinal(day);

    // Step 4: Convert the month number to its full month name
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    const monthName = monthNames[month];

    // Step 5: Format the time
    const formattedTime = `${padZero(hours)}:${padZero(minutes)}`;

    // Step 6: Combine into the final formatted string
    return `${ordinalDay} of ${monthName} ${year} ${formattedTime}`;
}

function getOrdinal(n) {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

function padZero(num) {
    return num < 10 ? `0${num}` : num;
}

export function calculateDurationInHours(startTime, endTime) {
    // Parse the ISO 8601 strings into Date objects
    const startDate = new Date(startTime);
    const endDate = new Date(endTime);

    // Calculate the difference in milliseconds
    const differenceInMilliseconds = endDate - startDate;

    // Convert milliseconds to hours
    const millisecondsInAnHour = 1000 * 60 * 60;
    return differenceInMilliseconds / millisecondsInAnHour;
}

export function centerOfGeofence(points)
{
    // Calculate average latitude
    const avgLat = points.reduce((acc, loc) => acc + loc.latitude, 0) / points.length;

    // Calculate average longitude
    const avgLng = points.reduce((acc, loc) => acc + loc.longitude, 0) / points.length;

    // Set center coordinates
    return { lat: avgLat, lng: avgLng }
}



export function geofenceIsActive(geofence)
{
    if (geofence.workOrders.length < 1)
        return false

    return geofence.workOrders.some(workOrder =>
        workOrder.intervals.some(interval => isCurrentTimeBetween(interval.start, interval.end))
    );

    // return geofence.workOrders.some(workOrder =>
    //     workOrder.assignedGeofences.filter(ga => ga.geofenceId === geofence.id).some(assignedGeofence =>
    //         assignedGeofence.intervals.some(interval =>
    //             isCurrentTimeBetween(interval.start, interval.end)
    //         )
    //     )
    // );
}

export function optionsForGeofence(geofence, isActive = geofenceIsActive(geofence), baseStyle = {})
{
    const activeGeofenceOptions = {
        ...baseStyle,
        strokeColor: "#539b4d",
        strokeOpacity: 0.8,
        strokeWeight: 3,
        fillColor: "#b3deb8",
        fillOpacity: 0.5
    }

    const inactiveGeofenceOptions = {
        ...baseStyle,
        strokeColor: "#FF0000",
        strokeOpacity: 0.8,
        strokeWeight: 1,
        fillColor: "#bc5c5c",
        fillOpacity: 0.5
    }


    return isActive ? activeGeofenceOptions : inactiveGeofenceOptions
}

export function getRandomInt(min, max) {
    const minCelled = Math.ceil(min);
    const maxFloored = Math.floor(max);
    return Math.floor(Math.random() * (maxFloored - minCelled) + minCelled); // The maximum is exclusive and the minimum is inclusive
}

export function displayNameForLanguageCode(code, t)
{
    const languageMap = {
        'en': t('global.language.en'),
        'nl': t('global.language.nl')
    };

    return languageMap[code] || code; // Return the code if no translation is found
}